
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/conferences",
      function () {
        return require("private-next-pages/events/conferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/conferences"])
      });
    }
  